import {CircularProgress, Theme} from "@mui/material";
import React, {FunctionComponent} from "react";
import {makeStyles} from "tss-react/mui";

interface LoadingElementProps {
    heightOverwrite?: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    container: {
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        backgroundColor: theme.palette.background.default,
    },
}));

const LoadingElement: FunctionComponent<
    LoadingElementProps
> = ({heightOverwrite}): JSX.Element => {
    const {classes} = useStyles();

    if (heightOverwrite) {
        return (
            <>
                <div className={classes.container} style={{height: heightOverwrite}} data-test-id={"loading-element"}>
                    <CircularProgress
                        color={"primary"}
                        style={{color: "#e42022"}}
                    />
                </div>
            </>
        );
    }

    return (
        <>
            <div className={classes.container} data-test-id={"loading-element"}>
                <CircularProgress
                    color={"primary"}
                    style={{color: "#e42022"}}
                />
            </div>
        </>
    );
};
export default LoadingElement;
